import { inherits as _inherits, createClass as _createClass, extends as _extends, asyncToGenerator as _asyncToGenerator, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { InteractiveNotification } from './InteractiveNotification.js';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';
import Cookies from 'js-cookie';

var InteractiveNotifications = /*#__PURE__*/function (_React$Component) {
  function InteractiveNotifications(props) {
    var _this;

    _classCallCheck(this, InteractiveNotifications);

    _this = _callSuper(this, InteractiveNotifications, [props]);

    _defineProperty(_this, "setCookie", function () {
      Cookies.set(_this.props.nameOfCookie, 'true', {
        expires: _this.props.cookieExpiresInDays
      });

      _this.setState({
        showNotification: false
      });

      if (_this.props.reloadOnClose) {
        location.reload();
      }
    });

    _defineProperty(_this, "getCookie", function () {
      var cookie = Cookies.get(_this.props.nameOfCookie) || localStorage.getItem(_this.props.nameOfCookie);

      if (!cookie) {
        _this.setState({
          showNotification: true
        });
      }
    });

    _defineProperty(_this, "decline", function () {
      localStorage.setItem(_this.props.nameOfCookie, 'declined');

      _this.setState({
        showNotification: false
      });
    });

    _this.state = {
      showNotification: false
    };
    return _this;
  }

  _inherits(InteractiveNotifications, _React$Component);

  return _createClass(InteractiveNotifications, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.getCookie();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          notification = _this$props.notification,
          animate = _this$props.animate,
          dataAttribute = _this$props.dataAttribute,
          suppressNotification = _this$props.suppressNotification;
      var transitionTimeout = animate ? 1000 : 0;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !suppressNotification && /*#__PURE__*/React.createElement("div", {
        "data-attribute": dataAttribute,
        className: "system-notifications interactive-notification"
      }, /*#__PURE__*/React.createElement(TransitionGroup, {
        className: "system-transition-group"
      }, /*#__PURE__*/React.createElement(CSSTransition, {
        classNames: "notification",
        timeout: transitionTimeout,
        key: notification.id
      }, /*#__PURE__*/React.createElement(InteractiveNotification, _extends({}, notification, {
        setCookie: this.setCookie,
        show: this.state.showNotification,
        decline: this.decline
      }))))));
    }
  }]);
}(React.Component);

_defineProperty(InteractiveNotifications, "propTypes", {
  animate: PropTypes.bool,
  cookieExpiresInDays: PropTypes.number,
  dataAttribute: PropTypes.string,
  nameOfCookie: PropTypes.string,
  notification: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.string.isRequired
  }),
  reloadOnClose: PropTypes.bool,
  suppressNotification: PropTypes.bool
});

_defineProperty(InteractiveNotifications, "defaultProps", {
  animate: true,
  cookieExpiresInDays: 365,
  dataAttribute: 'notification-banner'
});

InteractiveNotifications.displayName = "InteractiveNotifications";
export { InteractiveNotifications };